import { Modal, Button } from 'react-bootstrap';
import '../styles/ConfirmActionModal.css';

interface ConfirmActionModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;

  title: string;
  description: React.ReactNode;

  confirmText?: string;
  cancelText?: string;

  intent?: 'warning' | 'danger' | 'primary';
}

const ConfirmActionModal = ({
  show,
  onCancel,
  onConfirm,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  intent = 'warning',
}: ConfirmActionModalProps) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="confirm-modal-body">
        <div className={`confirm-icon ${intent}`}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" />
            <path
              d="M12 7v6"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="16.5" r="1.2" />
          </svg>
        </div>

        <h5 className="confirm-title">{title}</h5>

        <p className="confirm-text">{description}</p>

        <div className="confirm-actions">
          <Button
            variant="secondary"
            className="confirm-btn cancel"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>

          <Button
            className={`confirm-btn ${intent}`}

            onClick={onCancel}
          >

            {cancelText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmActionModal;
